/**
 * Update line item
 * @param {string} key 
 * @param {int} quantity 
 */
function updateLineItemQuantity(key, quantity, quantityInput = '', initialValue = '') {

    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            id: key,
            quantity: quantity
        },
        dataType: 'json',
        success: function (data) {
            refreshCartPopout();
            quantityInput.value = quantity;
            return true;
        },
        error: function(response){
            if( quantityInput && quantityInput ){
                quantityInput.value = initialValue;
            }
            let res = JSON.parse(response);
            // console.log('Response', res);
            if( res.status ){          
            let errorMessage = res.message;
            let errorPopup = document.querySelector('.wt-product-error');
            errorPopup.querySelector('.product-error-content').innerHTML = errorMessage;  
            errorPopup.classList.add('show');
            // Remove the error message after 3s
            setTimeout(() => {
                errorPopup.classList.remove('show');
            }, 3000);
            }
            return false;
        }
    });
}

/**
 * Refresh cart Popup
 */
let loadedAjaxScript = false;
function refreshCartPopout( popup = false ) {
    let cartTmpl = document.querySelector(".mini-cart-tmpl");
    let cartPopoutList = document.querySelector(".mini-cart-tmpl__body");
    let cartData = "";
    fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => {
        return response.json();
    })
    .then( res => {
        let cartData = res; 
        // console.log('cartData', cartData);
        let cartItems = cartData.items;
        let cartNotificationLists = document.getElementById('cart-notification-product');
        let cartNotificationListsHtml = '';
        if( cartItems.length > 0 ){
            cartItems.forEach( cartItem => {            
                // console.log('Cart item data:',  cartItem);
                let data = {
                    product_image_src: cartItem.featured_image.url,
                    product_title: cartItem.product_title,
                    product_quantity: cartItem.quantity,
                    product_quantity_min: 1,//cartItem.quantity_rule.min,
                    product_quantity_max: '',//cartItem.quantity_rule.max,
                    product_quantity_step: 1,//cartItem.quantity_rule.increment,
                    product_url: cartItem.url,
                    product_key: cartItem.key
                };
                if( cartNotificationLists ){                    
                    // Add cart item to `cartNotificationLists` element
                    let template = document.getElementById('cart-popup-template').innerHTML;
                    let renderedTemplate = renderTemplate( data, template);
                    // Now add varaints in cart item
                    let cartItemVariants = cartItem.options_with_values;
                    let renderedTemplateHtml = document.createElement('div');
                    renderedTemplateHtml.innerHTML = renderedTemplate;
                    if( cartItemVariants ){
                        let cartItemVariantHtml = '';
                        cartItemVariants.forEach(function( cartItemVariant ){                            
                            cartItemVariantHtml += `<div class="product-option">
                                <dt>${cartItemVariant.name}:</dt>
                                <dd>${cartItemVariant.value}</dd>
                            </div>`;
                        });
                        renderedTemplateHtml.querySelector('.product-option-list').outerHTML = cartItemVariantHtml;
                    }
                    cartNotificationListsHtml += renderedTemplateHtml.innerHTML;
                }
            });
        }
        else{
            cartNotificationListsHtml += '<p>Your cart is currently empty.</p>';
        }
        cartNotificationLists.innerHTML = cartNotificationListsHtml;
        // if( loadedAjaxScript == false ){
            cleanupQuantityButtons(); // clean up, so that product page buttons doesn't click multiple times            
            cartQuantityButton(); // cart quantity script
            cartRemoveButton();// cart quantity remove script
            updateDiscountField(cartItems);
        // }
        if( popup == true ){ // load popup for product page add to cart button only
            let cartSidebar = document.querySelector('.wt-cart-sidebar');
            if( cartSidebar ){
                cartSidebar.classList.add('show');
                // document.querySelector('body').classList.add('stop-scroll');
                // lenis.destroy();
            }
        }
        /*Additional cart feature */
        let headerCartCountElements = document.querySelectorAll('.update-cart-count');
        if( headerCartCountElements.length ){
            headerCartCountElements.forEach( headerCartCountElement => {
                headerCartCountElement.innerHTML = cartData.item_count;
            });
        }
        let wtCartCountElements = document.querySelectorAll('.wt-cart-count');
        if( wtCartCountElements.length ){
            let item_string = 'item';
            if( cartData.item_count > 1 ){
                item_string = 'items';
            }
            wtCartCountElements.forEach( wtCartCountElement => {
                wtCartCountElement.innerHTML = `(${cartData.item_count} ${item_string})`;
            });
        }
        let cartSubtotalElements = document.querySelectorAll('.cart-summary-subtotal-right');
        if( cartSubtotalElements.length ){
            cartSubtotalElements.forEach( cartSubtotalElement => {
                cartSubtotalElement.innerHTML = formatCurrency(cartData.original_total_price );
            });
        }
        let cartDiscounttotalElements = document.querySelectorAll('.cart-summary-discount-right');
        if( cartDiscounttotalElements.length ){
            cartDiscounttotalElements.forEach( cartDiscounttotalElement => {
                cartDiscounttotalElement.innerHTML = formatCurrency(cartData.total_discount );
            });
        }
        let cartGrandtotalElements = document.querySelectorAll('.cart-summary-grandtotal-right');
        if( cartGrandtotalElements.length ){
            cartGrandtotalElements.forEach( cartGrandtotalElement => {
                cartGrandtotalElement.innerHTML = formatCurrency(cartData.total_price );
            });
        }
        let cartNetTotalElement = document.querySelector('#cart-notification-form button span');
        if( cartNetTotalElement ){
            cartNetTotalElement.innerHTML = formatCurrency(cartData.total_price, cartData.currency);
        }

        let productElement = document.getElementById('product-id');
        // // Update Offer in Product page
        // let offerListWrap = document.querySelector('.product-attribute-offer-list');
        // let AllDiscountListElement = document.querySelector('.wt-discount-list');
        // let discountHtml  = '';
        // if( productElement && AllDiscountListElement ){ 
        //     let AllDiscountList = AllDiscountListElement.value;
        //     let productId = productElement.value;
        //     let AllDiscountListObject = JSON.parse( AllDiscountList );
        //     let AllDiscountListArray = Object.values(AllDiscountListObject);
        //     let product_quantity = getTotalQuantityOfProduct(cartItems, productId );
        //     if (AllDiscountListObject.discount1) {
        //         if( ( product_quantity >= AllDiscountListObject.discount1.quantity && AllDiscountListObject.discount2 && product_quantity < AllDiscountListObject.discount2.quantity )  ){
        //             AllDiscountListObject.discount1.text = 'Applied';
        //             AllDiscountListObject.discount1.status = 'checked';
        //         }
        //         else if( product_quantity >= AllDiscountListObject.discount1.quantity ){
        //             if( AllDiscountListObject.discount2 ){
        //                 AllDiscountListObject.discount1.text = 'Requirement meet';
        //                 AllDiscountListObject.discount1.status = 'disabled';
        //             }
        //             else{
        //                 AllDiscountListObject.discount1.text = 'Applied';
        //                 AllDiscountListObject.discount1.status = 'checked';
        //             }
        //         }
        //         else{
        //             let itemLeftForOffer = AllDiscountListObject.discount1.quantity - product_quantity;
        //             AllDiscountListObject.discount1.text = `${itemLeftForOffer} more to apply`;
        //             AllDiscountListObject.discount1.status = 'disabled';
        //         }
        //     }
        //     if ( AllDiscountListObject.discount2 ) {
        //         if( ( product_quantity >= AllDiscountListObject.discount2.quantity && AllDiscountListObject.discount3 && product_quantity < AllDiscountListObject.discount3.quantity )  ){
        //             AllDiscountListObject.discount2.text = 'Applied';
        //             AllDiscountListObject.discount2.status = 'checked';
        //         }
        //         else if( product_quantity >= AllDiscountListObject.discount2.quantity ){
        //             if( AllDiscountListObject.discount3 ){
        //                 AllDiscountListObject.discount2.text = 'Requirement meet';
        //                 AllDiscountListObject.discount2.status = 'disabled';
        //             }
        //             else{
        //                 AllDiscountListObject.discount2.text = 'Applied';
        //                 AllDiscountListObject.discount2.status = 'checked';
        //             }
        //         }
        //         else{
        //             let itemLeftForOffer = AllDiscountListObject.discount2.quantity - product_quantity;
        //             AllDiscountListObject.discount2.text = `${itemLeftForOffer} more to apply`;
        //             AllDiscountListObject.discount2.status = 'disabled';
        //         }
        //     }
        //     if (AllDiscountListObject.discount3) {
        //         if( ( product_quantity >= AllDiscountListObject.discount3.quantity ) ){
        //             AllDiscountListObject.discount3.text = 'Applied';
        //             AllDiscountListObject.discount3.status = 'checked';
        //         }
        //         else{
        //             let itemLeftForOffer = AllDiscountListObject.discount3.quantity - product_quantity;
        //             AllDiscountListObject.discount3.text = `${itemLeftForOffer} more to apply`;
        //             AllDiscountListObject.discount3.status = 'disabled';
        //         }
        //     }
        //     AllDiscountListArray.forEach( discountItem => {
        //         // discountHtml+= '<label><input type="radio" name="offer" value="'+ discountItem.percent +'% OFF" data-qty-break="" data-percent="'+ discountItem.percent +'" ' + discountItem.status + ' /><span>'+ discountItem.percent +'% OFF</span><span class="info">' + discountItem.text + '</span></label>';
        //         discountHtml += `<label>
        //             <input type="radio" name="offer" value="${discountItem.percent}% OFF" 
        //                     data-qty-break="${discountItem.quantity}"
        //                     data-percent="${discountItem.percent}" 
        //                     ${discountItem.status} />
        //             <span>${discountItem.percent}% OFF</span>
        //             <span class="info">${discountItem.text}</span>
        //         </label>`;
        //     });
        //     let offerListElement = document.querySelector('.product-attribute-offer-list');
        //     offerListElement.innerHTML = discountHtml;
        // }
        
        // Free shipping text
        let freeShippingElements = document.querySelectorAll('.product-cart-suggestion');
        let freeShippingTemplate = document.getElementById('free-shipping-template').innerHTML;
        let free_shipping_text = '';
        let totalAmount = cartData.total_price / 100;
        let freeShippingTarget = 350;// price in Australian dollar
        // console.log(freeShippingTarget * Shopify.currency.rate);
        freeShippingTarget = freeShippingTarget * Shopify.currency.rate;
        if( totalAmount < freeShippingTarget ){
            free_shipping_text = `Spend ${window.ShopifyAnalytics.meta.currency}${ freeShippingTarget - totalAmount } more to get FREE SHIPPING`;
        }
        else{
            free_shipping_text = 'Free Express Shipping Applied';
        }        
        let freeShippingData = {
            free_shipping_text: free_shipping_text,
        };
        let freeShippingTemplateRendered = renderTemplate( freeShippingData, freeShippingTemplate);
        // console.log('Log',freeShippingTemplateRendered);
        freeShippingElements.forEach( freeShippingElement => {
            freeShippingElement.outerHTML = freeShippingTemplateRendered;
        });
        // Loaded at last. First we need to add html elements so that this script doesn't have issue when it executes
        if( productElement && loadedAjaxScript == false ){
            loadVariation();
            // cartQuantityButton(); // cart quantity script
        }
        loadedAjaxScript = true; // set true so that we don't need to load script multiple times
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}


/**
 * Template function to replace data value in html
 * @param {json} data 
 * @param {html} template 
 * @returns 
 */
function renderTemplate(data, template ) {
    var rendered = template.replace(/\[\[ product_image_src \]\]/g, data.product_image_src)
        .replace(/\[\[ product_title \]\]/g, data.product_title)
        .replace(/\[\[ product_url \]\]/, data.product_url)
        .replace(/\[\[ product_variant_name \]\]/g, data.product_variant_name)
        .replace(/\[\[ product_variant_value \]\]/g, data.product_variant_value)
        .replace(/\[\[ product_key \]\]/g, data.product_key)
        .replace(/\[\[ product_quantity \]\]/, data.product_quantity)
        .replace(/\[\[ product_quantity_min \]\]/, data.product_quantity_min)
        .replace(/\[\[ product_quantity_max \]\]/, data.product_quantity_max)
        .replace(/\[\[ product_quantity_step \]\]/, data.product_quantity_step)
        .replace(/\[\[ offer10 \]\]/, data.offer10)
        .replace(/\[\[ offer15 \]\]/, data.offer15)
        .replace(/\[\[ offer20 \]\]/, data.offer20)
        .replace(/\[\[ offer_cart_item_count \]\]/, data.offer_cart_item_count)
        .replace(/\[\[ free_shipping_text \]\]/, data.free_shipping_text);
    return rendered;
}

// Function to clean up existing event listeners
function cleanupQuantityButtons() {
    let quantityButtons = document.querySelectorAll('.product-cart-qty button');
    quantityButtons.forEach(button => {
        let newElement = button.cloneNode(true);
        button.parentNode.replaceChild(newElement, button);        
    });
}

/**
 * Script for initializing quantity buttons
 */
function cartQuantityButton(){
    /**
     * Add increment and decrement in shop page
     * 
     */
    let quantityWraps = document.body.querySelectorAll('.product-cart-qty');
    if( quantityWraps.length ){
        quantityWraps.forEach( function(quantityWrap) {
            let incrementButton = quantityWrap.querySelector('.product-cart-increment');
            let decrementButton = quantityWrap.querySelector('.product-cart-decrement');
            let quantityInput = quantityWrap.querySelector('.product-cart-quantity');
            let addToCartButton = quantityWrap.parentNode.querySelector('.add-to-cart');
            let key = quantityInput.getAttribute('data-key');
            let initialValue = quantityInput.value;
            let step = parseInt(quantityInput.step);
            step = step > 0 ? step : 1;
            // Create a new 'change' event
            var quantityChangeEvent = new Event('change');
            // let newQuantity = validateMinMax( parseInt(initialValue) + step, quantityInput);
            // console.log(newQuantity);
            let variantInventoryLimit = parseInt(quantityInput.getAttribute('data-stock'));
            // Dispatch it.
            incrementButton.addEventListener('click', function(e) {
                // console.log("clicked + on product page");
                e.preventDefault();
                if( quantityInput.hasAttribute('disabled') ){
                    return false;
                }
                let qty = validateMinMax( parseInt(quantityInput.value) + step, quantityInput, variantInventoryLimit );
                if( addToCartButton ){ // will be true only for product page. Cart Sidebar and cart page doesn't have 'Add to cart' button
                    // console.log(newQuantity, variantInventoryLimit);
                    quantityInput.value = qty;
                    quantityInput.dispatchEvent(quantityChangeEvent);
                }
                else{
                    updateLineItemQuantity( key, qty, quantityInput, initialValue ); // value will be update in input after successfull response
                }
            });
            decrementButton.addEventListener('click', function(e) {
                e.preventDefault();
                if( quantityInput.hasAttribute('disabled') ){
                    return false;
                }        
                let qty = validateMinMax( parseInt(quantityInput.value) - step, quantityInput );
                if( addToCartButton ){ // will be true only for product page. Cart Sidebar and cart page doesn't have 'Add to cart' button
                    // addToCartButton.setAttribute('data-qty', qty );
                    quantityInput.value = qty;
                    quantityInput.dispatchEvent(quantityChangeEvent);
                }
                else{
                    updateLineItemQuantity( key, qty, quantityInput, initialValue ); // value will be update in input after successfull response
                }
            });
            if( !quantityWrap.classList.contains('.cart-quantity') && !quantityWrap.classList.contains('sticky-cart') ){ // if quatity Wrap is in Single product
                let productPageQuantity = quantityWrap.querySelector('.product-cart-quantity');
                productPageQuantity.addEventListener('change', function() { // update quantity in add to cart on change
                    // console.log("change event for .product-cart-quantity");
                    // console.log(parseInt(this.value), variantInventoryLimit);
                    updateDiscountField();
                    quantityWraps.forEach( function(quantityWrapUpdate, index) {
                        let addToCartButtonUpdate = quantityWrapUpdate.parentNode.parentNode.querySelector('.add-to-cart');
                        let quantityInputUpdate = quantityWrapUpdate.querySelector('.product-cart-quantity');
                        if( addToCartButtonUpdate ){
                            addToCartButtonUpdate.setAttribute('data-qty', productPageQuantity.value );
                            quantityInputUpdate.value = productPageQuantity.value;
                            if(parseInt(this.value) > variantInventoryLimit) {
                                console.log("we've exceeded avaiable inventory quantity!");
                            }
                        }
                    });
                });
            }
        });
    }
}

function updateDiscountField( cartItems = ''){
    let discountFields = document.querySelectorAll('.product-attribute-offer-list input[name="offer"]');
    if( discountFields.length == 0 ){
        return false;
    }
    if( cartItems ){
        let addToCartButton = document.querySelector('.product-cart .add-to-cart');
        if( addToCartButton ){
            let collectionHandle = addToCartButton.getAttribute('data-collection').trim();
            if( collectionHandle ){
                // console.log('UpdateDiscountField', cartItems);
                let totalCollectionProduct = 0;
                cartItems.forEach(cartItem =>{
                    if( collectionHandle == cartItem.properties.collection ){
                        totalCollectionProduct += cartItem.quantity;
                    }
                });
                discountFields.forEach(function( discountField ){
                    discountField.setAttribute('data-qty-cart', totalCollectionProduct );
                });
            }
        }
    }
    let productCartInput = parseInt( document.querySelector('.cart-product .product-cart-quantity').value );
    discountFields.forEach(function( discountField ){
        let qtyInCart = parseInt( discountField.getAttribute('data-qty-cart').trim() );
        let discountFieldQtyBreak = parseInt(discountField.getAttribute('data-qty-break'));
        let discountFieldQtyBreakUpto = parseInt(discountField.getAttribute('data-qty-break-upto'));
        let qtyRequiredForDiscount = qtyInCart;
        if( !cartItems ){ // Subtract and get remaining if Cart quatity is less than data-qty-break 
            qtyRequiredForDiscount = productCartInput + qtyInCart;
        }
        let needMoreQty = 0;
        let discountFieldInfoText = '';
        discountField.checked = false;
        discountField.disabled = false;
        // console.log(discountFieldQtyBreak, discountFieldQtyBreakUpto,productCartInput, qtyInCart);
        if( qtyRequiredForDiscount >= discountFieldQtyBreak && !discountField.hasAttribute('data-qty-break-upto') ){
            // console.log( qtyRequiredForDiscount +'>='+ discountFieldQtyBreak +" && "+ qtyRequiredForDiscount +'<'+ discountFieldQtyBreakUpto );
            discountFieldInfoText = 'Applied';
            discountField.checked = true;
            // console.log('condition1', discountField);
        }
        else if( qtyRequiredForDiscount >= discountFieldQtyBreak && qtyRequiredForDiscount < discountFieldQtyBreakUpto){
            discountFieldInfoText = 'Applied';
            discountField.checked = true;
        }
        else if( qtyRequiredForDiscount >= discountFieldQtyBreak && qtyRequiredForDiscount >= discountFieldQtyBreakUpto ){
            discountFieldInfoText = 'Requirement met';
            if( qtyInCart >= discountFieldQtyBreakUpto ){
                discountField.disabled = true;
            }
        }
        else if( qtyInCart < discountFieldQtyBreak ){
            needMoreQty = discountFieldQtyBreak - qtyRequiredForDiscount;
            discountFieldInfoText = `${needMoreQty} more to apply`;
        }
        discountField.parentNode.querySelector('.info').innerHTML = discountFieldInfoText;
    });
    applyDiscoutToCartButton();
}

function applyDiscoutToCartButton( variant = '' ){
    let addTocartButton = document.querySelector('.product-cart-inner .add-to-cart');
    if( !variant ){
        let variant_id = parseInt(addTocartButton.getAttribute('data-variation-id'));
        // alert(variant_id);
        // Select the element containing the data
        let variationElement = document.getElementById('variation_lists');

        // Parse the data-variations attribute JSON string into an array of objects
        let variations = JSON.parse(variationElement.getAttribute('data-variations'));

        // Find the variant object with the desired ID
        variant = variations.find(variant => variant.id === variant_id);

        // // Log or work with the target variant
        // console.log("Selected variant");
        // console.log(targetVariant);
        // // variant = 
    }
    applyDiscoutToCartButtonOptions( true ); // Enable cart options(qty and add to cart )
    // console.log("variant",variant);
    // Get variant price
    let price = variant.price / 100; // Convert from cents to dollars (if needed)
    let netPrice = price;
    // Calculate net price if there's a discount, for example, a flat percentage discount
    let discountElement = document.querySelector('.product-attribute-offer-list input[name="offer"]:checked');
    // console.log("discountElement",discountElement);
    if( discountElement ){        
      let discountPercentage = parseInt( discountElement.getAttribute('data-percent') ); // Example discount percentage
      netPrice = price - (price * (discountPercentage / 100)); // Calculate discounted price
    }
    let cartButtonPrice = document.querySelector('.product-cart-price');
    let cartButtonPriceHtml = '';
    cartButtonPriceHtml += ' — <span class="product-cart-total">';
    cartButtonPriceHtml += window.ShopifyAnalytics.meta.currency + price.toFixed(2); // Format the price to 2 decimal places
    cartButtonPriceHtml += '</span>';
    // alert('Update CArt Buton');
    // alert(netPrice);
    // alert(price);
    if (netPrice < price) {
      cartButtonPriceHtml += '<span class="product-cart-net-total">';
      cartButtonPriceHtml += window.ShopifyAnalytics.meta.currency + netPrice.toFixed(2); // Format the net price to 2 decimal places
      cartButtonPriceHtml += '</span>';
      cartButtonPrice.classList.add('has-discounted-amount');
    }
    var newElement = document.createElement('span');
    newElement.innerHTML = cartButtonPriceHtml;
    cartButtonPrice.innerHTML = cartButtonPriceHtml;
    // console.log("cartButtonPriceHtml",cartButtonPriceHtml);
}

// Disable Add to cart button variation
function applyDiscoutToCartButtonOptions( status = false ){
    let variationID = document.querySelector('.add-to-cart').getAttribute('data-variation-id');
    let cartButtonPrice = document.querySelector('.product-cart-price');
    let inputQuanityElement = document.querySelector('.product-cart-qty.cart-product .product-cart-quantity');
    let inputQuanityValue = parseInt(inputQuanityElement.value);
    let inputQuanityStock = parseInt(inputQuanityElement.getAttribute('data-stock'));
    cartButtonPrice.innerHTML = '';
    let inputQuantities = document.querySelectorAll('.product-cart-quantity');
    let AddToCartButtons = document.querySelectorAll('.add-to-cart');
    // console.log('inputed quantity', inputQuanityValue);
    // console.log('Available Stock', inputQuanityStock);
    // console.log('status', status);
    // console.log('variationID', variationID);
    if( status && variationID != '' && inputQuanityValue <= inputQuanityStock ){
      // document.querySelector('.product-cart-quantity').removeAttribute('disabled' );
      // document.querySelector('.add-to-cart').removeAttribute('disabled' );
      inputQuantities.forEach( inputQuantity => {
        inputQuantity.removeAttribute('disabled' );
      });
      AddToCartButtons.forEach( AddToCartButton => {
        AddToCartButton.removeAttribute('disabled' );
        AddToCartButtonText = AddToCartButton.querySelector('.wt-add-to-cart-text');
        if( AddToCartButtonText ){
          AddToCartButtonText.innerHTML = 'Add to bill';
        }
      });
    }
    else {
      // document.querySelector('.product-cart-quantity').setAttribute('disabled', true );
      // document.querySelector('.add-to-cart').setAttribute('disabled', true );
    //   inputQuantities.forEach( inputQuantity => {
    //     inputQuantity.setAttribute('disabled', true );
    //   });
      AddToCartButtons.forEach( AddToCartButton => {
        AddToCartButton.setAttribute('disabled', true );
        AddToCartButtonText = AddToCartButton.querySelector('.wt-add-to-cart-text');
        if( AddToCartButtonText ){
          AddToCartButtonText.innerHTML = 'Out of Stock';
        }
      });
      if( inputQuanityValue > inputQuanityStock ){
        // let errorMessage = `There are only ${inputQuanityStock} quantity in Stock. Please selected less than stock quantity.`;
        let errorMessage = `There are only ${inputQuanityStock} of this style in stock. Contact us to find out when we'll be restocking.`;
        
        let errorPopup = document.querySelector('.wt-product-error');
        errorPopup.querySelector('.product-error-content').innerHTML = errorMessage;  
        errorPopup.classList.add('show');
        // Remove the error message after 3s
        // setTimeout(() => {
        //     errorPopup.classList.remove('show');
        // }, 3000);
      }
    }    
  }

let productStickyAddToCart = document.querySelector('.product-cart-sticky .add-to-cart');
if( productStickyAddToCart ){
    productStickyAddToCart.addEventListener('click', function(){
        let addToCartButtonTrigger = document.querySelector('.product-cart .add-to-cart');
        addToCartButtonTrigger.click();
    });
}

/**
 * Validate input quantity
 * @param {int} value 
 * @param {*} element 
 * @returns 
 */
function validateMinMax( value, element ){
    let min = element.min;
    let max = element.max;
    if( min && value < min ){
    value = min;
    }
    if( max && value > max ){
    value = max;
    }
    return value;
}


/**
 * Remove Cart
 */
function cartRemoveButton(){
    let cartRemoveButtons = document.querySelectorAll('.cart-product-remove');
    cartRemoveButtons.forEach(function(cartRemoveButton){
        let key = cartRemoveButton.getAttribute('data-key');
        cartRemoveButton.addEventListener( 'click', function(){
            // alert('remove');
            updateLineItemQuantity( key, 0 );
        });
    });
}

// Function to format the amount
function formatCurrency(amount, currency = '' ) {
    // Convert the amount to a string with two decimal places
    const formattedAmount = (amount / 100).toFixed(2);
    return `${window.ShopifyAnalytics.meta.currency}${formattedAmount} ${currency}`;
}

document.addEventListener('DOMContentLoaded', refreshCartPopout);
// document.addEventListener('DOMContentLoaded', cartRemoveButton);
// document.addEventListener('DOMContentLoaded', cartQuantityButton);


function getTotalQuantityOfProduct(cartItems, product_id) {
    let totalQuantity = 0;
  
    // Loop through each cart item
    cartItems.forEach(item => {
        // Check if the item's variant_id is in the list of variationIds
        if ( product_id == item.product_id ) {
            // Add the item's quantity to the total quantity
            totalQuantity += item.quantity;
        }
    });
  
    return totalQuantity;
}